import 'dayjs/locale/pl';
import Container from 'layout/atoms/Container';
import Button from 'atoms/Button';
import { useLocation, useNavigate } from 'react-router';

function useQuery() {
    return new URLSearchParams(useLocation().search);
}

const SubscriptionPage = () => {
    const query = useQuery();
    const sessionId = query.get('sessionId');
    const navigate = useNavigate();
    
    return (
        <Container narrow>
            <>
                <br/>
                <br/>
                Payment successful
                <br/>
                <br/>
                <Button theme='primary' onClick={() => navigate("/subscription")} >Go back</Button>
            </>
        </Container>
    );
};

export default SubscriptionPage;
